import React, { useState } from 'react'
import {
	EuiFilterGroup,
	EuiFilterButton,
	EuiPopover,
	EuiSelectable,
	EuiSelectableOption,
} from '@equipmentshare/ds2'
import {
	ArrowUpSLineIcon,
	ArrowDownSLineIcon,
} from '@equipmentshare/ds2-icons'
import { DemandRequestStatus } from '../../../graphql'

export type StatusFilterProps = {
	selectedStatuses: DemandRequestStatus[],
	onChange: ( statuses: DemandRequestStatus[] ) => void,
}

const STATUS_OPTIONS: any[] = [
	{ label: 'Open', value: DemandRequestStatus.Open },
	{ label: 'Assigned', value: DemandRequestStatus.Assigned },
	{ label: 'Completed', value: DemandRequestStatus.Completed },
]

export default function StatusFilter( { selectedStatuses, onChange }: StatusFilterProps ) {
	const [ isPopoverOpen, setIsPopoverOpen ] = useState( false )

	const togglePopover = () => setIsPopoverOpen( !isPopoverOpen )
	const closePopover = () => setIsPopoverOpen( false )

	// Map current selection to EuiSelectable options
	const options: any[] = STATUS_OPTIONS.map( ( option: any ) => ( {
		...option,
		checked: option.value && selectedStatuses.includes( option.value ) ? 'on' : undefined,
	} ) )

	const handleChange = ( newOptions: any[] ) => {
		const selected = newOptions
			.filter( ( option: any ) => option.checked === 'on' && option.value )
			.map( ( option: any ) => option.value as DemandRequestStatus )
		onChange( selected )
	}

	const numActiveFilters = selectedStatuses.length

	const button = (
		<EuiFilterButton
			iconType={isPopoverOpen ? ArrowUpSLineIcon : ArrowDownSLineIcon}
			iconSide="right"
			isSelected={isPopoverOpen}
			onClick={togglePopover}
			numActiveFilters={numActiveFilters}
			hasActiveFilters={numActiveFilters > 0}
		>
			Status
		</EuiFilterButton>
	)

	return (
		<EuiFilterGroup>
			<EuiPopover
				button={button}
				isOpen={isPopoverOpen}
				closePopover={closePopover}
				panelPaddingSize="none"
			>
				<EuiSelectable
					options={options}
					onChange={handleChange}
					searchable={false}
				>
					{( list ) => <div style={{ width: 200 }}>{list}</div>}
				</EuiSelectable>
			</EuiPopover>
		</EuiFilterGroup>
	)
}
